export enum EHotmartType {
  STORE = 'STORE',
  ABANDONED_CART = 'ABANDONED_CART',
}
